// extracted by mini-css-extract-plugin
module.exports = {"skillsSection":"CandidateSkillsDisplay-module_skillsSection_2b9d0","skillsBlock":"CandidateSkillsDisplay-module_skillsBlock_3f396"};